const { filter, some } = require('lodash'), { createProductTiles, createBundleTiles } = require('../shop/tiles/product-tile-factory');

class SearchProductTileListController {
    constructor(settings, searchService, sortByKeys) {
        this.settings = settings;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
    }

    $onChanges(changes) {
        if (changes.filter) {
            this.sortOptions = {
                sortContext: this.sortByKeys.SEARCH_RESULTS_KEY,
                sortTypes: this.getSortTypes(this.settings.search.sortOptions),
            };
        }
    }

    getSortTypes(sortTypes) {
        if (this.isSpecial) {
            sortTypes = filter(sortTypes, item => item.Value !== 'Special');
        }

        if (this.isList || this.isFilteredByCategory()) {
            sortTypes = filter(sortTypes, item => item.Value !== 'Aisle');
        }

        return sortTypes;
    }

    isFilteredByCategory() {
        return this.filter && some(this.filter.filters, { Key: 'Category' });
    }

    createTiles(result) {
        return {
            items: this.isSpecial
                ? createProductTiles(result.items)
                : createBundleTiles(result.items),
            totalRecordCount: result.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name', searchFilter) {
        const cardsPromise = this.isSpecial
            ? this.searchService.doSearchSpecials(this.searchTerm, pageSize, pageNumber, sortType, searchFilter)
            : this.searchService.doSearch(this.searchTerm, pageSize, pageNumber, sortType, !!this.isSpecial, searchFilter);

        return cardsPromise.then(result => this.createTiles(result));
    }
}

SearchProductTileListController.$inject = ['Settings', 'SearchService', 'SortByKeys'];

const searchProductTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        isSpecial: '<',
        isList: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
    },
    controller: SearchProductTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            filter="$ctrl.filter"
            sort-options="$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>

            <control>
                <wow-search-term-tile-list-updater
                    search-term="$ctrl.searchTerm">
                </wow-search-term-tile-list-updater>
            </control>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchProductTileListController,
    searchProductTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-product-tile-list.component.js